// @flow
import EnvConfig from 'config';
import { LocusApiModel } from 'common/modules/api';

export const pregenWaybillUnusedSummary: LocusApiModel = new LocusApiModel({
    baseUrl: EnvConfig.orchestratorEndPoint,
    endPoint: '/client/{clientId}/pregenerated-waybill/unused-summary'
});

export const pregenWaybillUnusedSearch: LocusApiModel = new LocusApiModel({
    baseUrl: EnvConfig.orchestratorEndPoint,
    endPoint: '/client/{clientId}/pregenerated-waybill/unused-search'
});

export const pregenWaybillBulkCreate: LocusApiModel = new LocusApiModel({
    baseUrl: EnvConfig.orchestratorEndPoint,
    resourceName: 'pregenerated-waybill',
    endPoint: '/client/{clientId}/pregenerated-waybill/bulk-create'
});

export const carriers: LocusApiModel = new LocusApiModel({
    baseUrl: EnvConfig.orchestratorEndPoint,
    endPoint: '/client/{clientId}/carriers?include=SETTINGS'
});

export const serviceabilityTemplate: LocusApiModel = new LocusApiModel({
    baseUrl: EnvConfig.orchestratorEndPoint,
    endPoint:
        '/client/{clientId}/carrier/{carrierId}/service-type/{serviceTypeId}/serviceability-template'
});

export const serviceabilityUpload: LocusApiModel = new LocusApiModel({
    baseUrl: EnvConfig.orchestratorEndPoint,
    endPoint:
        '/client/{clientId}/carrier/{carrierId}/service-type/{serviceTypeId}/serviceability-upload'
});

export const serviceabilityExport: LocusApiModel = new LocusApiModel({
    baseUrl: EnvConfig.orchestratorEndPoint,
    endPoint:
        '/client/{clientId}/carrier/{carrierId}/service-type/{serviceTypeId}/serviceability-export'
});

export const quoteSelectionConfigSearch: LocusApiModel = new LocusApiModel({
    baseUrl: EnvConfig.orchestratorEndPoint,
    endPoint: `/client/{clientId}/quote-selection-config-search`
});
